export const DASHBOARD_POLL_MS = 20000;
export const ROADS_UPDATED_KEY = 'ff_roads_updated';

export const VEHICLE_LABELS = {
  cargo_motorbike: 'Cargo motorbike',
  pickup: 'Pick-up',
  light_truck: 'Light truck',
  truck: 'Truck',
};

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function vehicleLabel(type) {
  if (!type) return '—';
  return VEHICLE_LABELS[type] || type;
}

export function formatKm(value, digits = 1) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `${Number(value).toFixed(digits)} km`;
}

export function formatPct(value, asRatio = true) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  const n = asRatio && Number(value) <= 1.5 ? Number(value) * 100 : Number(value);
  return `${Math.round(n)}%`;
}

export function formatMinutes(value) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  const mins = Math.round(Number(value));
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m ? `${h} h ${m} min` : `${h} h`;
}

export function orderIdsOfStop(stop) {
  if (!stop) return [];
  if (Array.isArray(stop.order_ids) && stop.order_ids.length) return stop.order_ids;
  if (typeof stop.order_ids === 'string') {
    try {
      const parsed = JSON.parse(stop.order_ids);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch {
      /* ignore */
    }
  }
  return stop.order_id ? [stop.order_id] : [];
}

export function conflictMessage(err) {
  if (err?.status === 409) {
    return err.message || 'An order in this cluster was already assigned. Recompute and try again.';
  }
  return err?.message || 'Something went wrong.';
}
